// extracted by mini-css-extract-plugin
export default {"descriptions":"TaxpayerVersionModal_descriptions__8v6LW","audit":"TaxpayerVersionModal_audit__uqn91"};